module.exports = __webpack_public_path__ + "img/virado_header_1.16ae404c.jpg";